import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
interface Step {
  number: string;
  title: string;
  highlightWord: string;
  description: string;
  icon: string;
}
@Component({
  selector: 'app-lottery-landing',
  imports: [CommonModule],
  templateUrl: './lottery-landing.component.html',
  styleUrl: './lottery-landing.component.scss'
})
export class LotteryLandingComponent {
  steps: Step[] = [
    {
      number: '1',
      title: 'Choose Your Lottery',
      highlightWord: 'Lottery',
      description: 'Pick from our live thrilling jackpot draws, including popular draws like Powerball, Mega Millions, and more. Your win is in!',
      icon: '🎫'
    },
    {
      number: '2',
      title: 'Pick Your Numbers',
      highlightWord: 'Numbers',
      description: 'It\'s all about luck! Choose your lucky numbers manually or let the system randomly select the best numbers for you. It\'s in!',
      icon: '🎱'
    },
    {
      number: '3',
      title: 'Check Your Numbers',
      highlightWord: 'Numbers',
      description: 'Once results are out, check if you\'ve won. Don\'t forget to check, must be claimed within 14 months!',
      icon: '🏆'
    }
  ];

  getTitle(title: string, highlightWord: string): { before: string; after: string } {
    const index = title.indexOf(highlightWord);
    if (index === -1) {
      return { before: title, after: '' };
    }
    return {
      before: title.substring(0, index),
      after: title.substring(index + highlightWord.length)
    };
  }
}
